import React, { Fragment } from 'react'
import { Grid, GridItem, Text } from '@chakra-ui/react'
import { isEmpty } from 'lodash'
import { formatDate } from '../../../utils/dateUtil'
import { OptionsValueWithRowId } from './types'
import { numberToCurrency, CurrencyEnum } from '../../../utils/numberToCurrency'

const OptionsPreview = ({ options }: { options?: OptionsValueWithRowId[] }) => {
  if (isEmpty(options)) {
    return null
  } else {
    const titleSpan = 4
    const positionSpan = 2
    const symbolSpan = 4
    const amountSpan = 2
    const dateSpan = 3
    const priceSpan = 3
    const putSpan = 2
    const fillerSpan = 1 // Should bring totalColumnSpan up to 21 for form consistency
    const totalColumnSpan =
      titleSpan +
      positionSpan +
      symbolSpan +
      amountSpan +
      dateSpan +
      priceSpan +
      putSpan +
      fillerSpan

    return (
      <Grid
        borderBottom="1px solid gray"
        gridGap={4}
        padding={4}
        templateRows={`repeat(${options?.length}, fit-content 1fr)`}
        templateColumns={`repeat(${totalColumnSpan}, 1fr)`}
      >
        <GridItem colSpan={titleSpan} rowSpan={options?.length! + 1}>
          <Text fontWeight="semibold">Options Transfer</Text>
        </GridItem>
        <GridItem colSpan={positionSpan}>
          <Text fontWeight="semibold">Position*</Text>
        </GridItem>
        <GridItem colSpan={symbolSpan}>
          <Text fontWeight="semibold">Symbol*</Text>
        </GridItem>
        <GridItem colSpan={amountSpan} justifySelf="end">
          <Text fontWeight="semibold">Quantity*</Text>
        </GridItem>
        <GridItem colSpan={dateSpan}>
          <Text fontWeight="semibold">Expiration Date*</Text>
        </GridItem>
        <GridItem colSpan={priceSpan} justifySelf="end">
          <Text fontWeight="semibold">Strike Price*</Text>
        </GridItem>
        <GridItem colSpan={putSpan + fillerSpan}>
          <Text fontWeight="semibold">Put/Call*</Text>
        </GridItem>
        {options?.map(
          ({
            rowId,
            symbol,
            contractDate,
            put,
            strikePrice,
            isShort,
            amount,
          }: OptionsValueWithRowId) => {
            const shortDisplayString =
              isShort === undefined ? '' : isShort ? 'Short' : 'Long'
            const date = contractDate
              ? new Date(contractDate).toLocaleDateString()
              : ''
            return (
              <Fragment key={rowId}>
                <GridItem colSpan={positionSpan}>
                  <Text data-testid="options-preview__isShort">
                    {shortDisplayString}
                  </Text>
                </GridItem>
                <GridItem colSpan={symbolSpan}>
                  <Text>{symbol}</Text>
                </GridItem>
                <GridItem colSpan={amountSpan} justifySelf="end">
                  <Text>{amount}</Text>
                </GridItem>
                <GridItem
                  colSpan={dateSpan}
                  data-testid="options-preview__contractDate"
                >
                  <Text>{date}</Text>
                </GridItem>
                <GridItem colSpan={priceSpan} justifySelf="end">
                  <Text>
                    {numberToCurrency(strikePrice!, CurrencyEnum.usd)}
                  </Text>
                </GridItem>
                <GridItem colSpan={putSpan + fillerSpan}>
                  <Text>{put}</Text>
                </GridItem>
              </Fragment>
            )
          }
        )}
      </Grid>
    )
  }
}

export default OptionsPreview
